//STYLES     ----------------------------
import './style';
//BEHAVIOURS ----------------------------
import './behaviours';
//COMPONENTS ----------------------------
import './animation';
import './autocomplete-select';
import './autocomplete-text/field';
import './behaviours';
import './button';
import './button-back-to-top';
import './button-back';
import './button-help';
import './input-checkbox';
import './input-checkbox/with-error';
import './chips';
import './column';
import './confirmation-popin';
import './draggable-iframe';
import './dropdown';
import './empty';
import './form';
import './grid';
import './icon';
import './input-date';
import './input-display';
import './input-text';
import './input-textarea';
import './input-textarea/consult';
import './input-toggle';
import './label';
import './menu';
import './modal';
import './panel';
import './panel/edit-save-buttons';
import './progress-bar';
import './input-radio';
import './scrollspy-container';
import './select';
import './select-checkbox';
import './select-mdl';
import './select-radio';
import './snackbar';
import './spinner';
import './title';
import './tooltip';
import './translation';



// WEBPACK FOOTER //
// ./src/index.js